import axios from "axios";
import { GET_COUNTRY_STATE_CITY } from "./types";
const keys = require("../config/keys");

export const getCountryStateCity = () => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath +
      "/api/Common/GetCountriesStateCities?CountryId=101&StateId=0&CityId=0"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({ type: GET_COUNTRY_STATE_CITY, payload: res.data.data });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getCountryStateCity.js